export const getParametroApiUrl = (pathname: string) => process.env.REACT_APP_TV_PARAMETRO_API_URL + pathname
